import { NgModule, ErrorHandler } from '@angular/core';
import { routes } from './../app.routing';
import { CommonModule } from '@angular/common';
import { ConsultaColegioComponent } from '../components/colegio/consulta-colegio/consulta-colegio.component';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { RESTClientService } from '../providers/util/RESTClientService';
import { CustomGenericException } from '../exception/custom-error-handle';
import { ConsultaComponent } from '../components/tradicional/consulta/consulta.component';
import { ConsultaPosComponent } from '../components/pos/consulta-pos/consulta-pos.component';
import { NotfoundComponent } from '../components/notfound/notfound.component';
import { ConsultaMedicinaComponent } from '../components/medicina/consulta-medicina/consulta-medicina.component';
import { BloqueadoColegioComponent } from '../components/colegio/bloqueado-colegio/bloqueado-colegio.component';
import { CarregandoComponent } from '../components/carregando/carregando.component';
import { NotaInicioComponent } from '../nota-inicio/nota-inicio.component';
import { ConsultaColegioService } from '../providers/service/colegio/consulta-colegio.service';
import { ConsultaPosService } from '../providers/service/pos/consulta-pos.service';
import { ConsultaMedicinaService } from '../providers/service/medicina/consulta-medicina.service';
import { NotificacaoComponent } from '../providers/util/notificacao/notificacao.component';
import { NotificacaoService } from '../providers/util/notificacao/notificacao.service';
import {MensagemUtil} from '../providers/util/notificacao/mensagemUtil';
export class NotaAlunoModuloModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [
    CommonModule,
    FormsModule,
    HttpClientModule,
    routes
  ],
  declarations: [
    ConsultaComponent,
    ConsultaPosComponent,
    ConsultaColegioComponent,
    NotfoundComponent,
    ConsultaMedicinaComponent,
    BloqueadoColegioComponent,
    CarregandoComponent,
    NotaInicioComponent,
    NotificacaoComponent
  ],
  providers: [
    RESTClientService,
    ConsultaColegioService,
    ConsultaMedicinaService,
    ConsultaPosService,
    NotificacaoService,
    MensagemUtil
  ],

  exports: [
    ConsultaComponent,
    ConsultaPosComponent,
    ConsultaColegioComponent,
    NotfoundComponent,
    ConsultaMedicinaComponent,
    BloqueadoColegioComponent,
    CarregandoComponent,
    NotaInicioComponent,
    NotificacaoComponent
  ]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function NotaAlunoModuloModule_tsickle_Closure_declarations() {
/** @type {?} */
NotaAlunoModuloModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
NotaAlunoModuloModule.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
